module.exports = __webpack_public_path__ + "static/media/iProperty.95226c12.png";